import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Hero from "./hero/Hero";
import About from "../About/About";
import Workstep from "../Workstep/Workstep";
import Testimonial from "../Testimonial/Testimonial";
import Services from "../Services/Services";
import Projects from "../Project/Projects";
import useTitle from "../../hooks/useTitle";
import Contact from "../Contact/Contact";
import Video from "../Testimonial/Video";
import PortfolioData from "../Portfolio/PortfolioData";


const Home = () => {
  useTitle("Home")
  useEffect(() => {
    AOS.init();
  }, [])
  return <div>
    <Hero />
    <About />
    <Services />
    {/* <Workstep /> */}
    <PortfolioData />
    <Projects />
    {/* <Video /> */}
    <Testimonial />
    <Contact />
  </div>;
};

export default Home;
